module.exports = __webpack_public_path__ + "static/media/Ulla high 4.defcbd09.JPG";